/**
 * Shared type-to-filter matching for the searchable comboboxes
 * (ComboboxField, MultiComboboxField) — used for every country/reference-data
 * field in the app (passport country, nationality, all address country
 * subfields, place of birth, current location, usual country of residence,
 * additional citizenships, etc.).
 *
 * Whitespace-insensitive on BOTH sides (B11 NEW-2 / B12 fix): the reference
 * data label for Vietnam is "Viet Nam" (with a space), but "Vietnam" is the
 * overwhelmingly common one-word spelling a real applicant or staff member
 * types. Plain substring matching (`label.includes(query)`) returns zero
 * results for that — and silently, with no "did you mean" — for any country
 * whose ISO label differs from common usage in exactly this way. Stripping
 * all whitespace from both the haystack (label) and the needle (query)
 * before comparing fixes it without touching anything else about the match
 * (still case-insensitive substring, still no fuzzy/typo tolerance).
 */

export function normalizeForSearch(value: string): string {
  return value.toLowerCase().replace(/\s+/g, '');
}

/** True if `label` matches the user's type-to-filter `query`. */
export function matchesQuery(label: string, query: string): boolean {
  const q = normalizeForSearch(query.trim());
  if (!q) return true;
  return normalizeForSearch(label).includes(q);
}
